import { useState } from "react";
import { ProceduresNew, FAQSNew, dwoVac, rwoVac } from "../../utils/index";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../Accordion/Accordion";
import { useNavigate } from "react-router-dom";

export const Brt2025 = () => {
  const [dwo, setDwo] = useState(0);
  const [rwo, setRwo] = useState(null);
  const [procSelected, setProcSelected] = useState(null);
  const [faqSelected, setFaqSelected] = useState(0);

  const handleToggle = (index, type) => {
    if (type === "dwo") setDwo(index === dwo ? null : index);
    if (type === "rwo") setRwo(index === rwo ? null : index);
    if (type === "proc") setProcSelected(index === procSelected ? null : index);
    if (type === "faq") setFaqSelected(index === faqSelected ? null : index);
  };

  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center flex-col gap-1 p-2 md:p-4 navbar-offset">
      {/* Heading */}
      <div className="my-5">
        <p className="w-full text-md md:text-4xl text-center font-extrabold text-gray-600  md:leading-[55px]">
          Application Submission for <br className="hidden lg:block" />
          Online Interview 2026 is going on
        </p>
        <div className="flex items-center justify-center">
          <button
            onClick={() => navigate("/career/interview")}
            className="border border-[#307bc4] px-3 py-2 rounded-xl hover:bg-[#307bc4]/80 transition-colors hover:text-white text-sm duration-300 ease-in-out text-[#274760]"
          >
            Register For Interview
          </button>
        </div>
      </div>

      {/* Dwo Vacancies Section */}
      <div className="container mt-[-20px] lg:mt-0">
        {dwoVac.map((item, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-lg mb-3 overflow-hidden"
          >
            <button
              onClick={() => handleToggle(index, "dwo")}
              className="w-full text-left px-4 py-3 bg-slate-300 hover:bg-gray-300 flex justify-between items-center font-semibold text-black"
            >
              {item.title} {item.vacancy || ""}
              <span className="text-xl">{dwo === index ? "−" : "+"}</span>
            </button>

            {dwo === index && (
              <div className="bg-white p-4 space-y-2 text-gray-700">
                <p>
                  <b>Qualification :-</b> {item.qualifications}
                </p>
                <p>
                  <b>Preference (Not mandatory):-</b> {item.preference}
                </p>
                <p>
                  <b>Service Type :-</b> {item.serviceType}
                </p>
                <p>
                  <b>Salary :-</b> {item.salary}{" "}
                  {item.salary2 && `| ${item.salary2}`}
                </p>
                <p>
                  <b>Promotion :-</b> {item.promotion}
                </p>
                <p>
                  <b>Pension Scheme :-</b> {item.pensionScheme}
                </p>
                <p>
                  <b>Mediclaim Facility :-</b> {item.mediclaimFacility}
                </p>
                <p>
                  <b>Group Term Insurance :-</b> {item.groupTermInsurance}
                </p>
                <p>
                  <b>Age Limit :-</b> {item.ageLimit}
                </p>
                <p>
                  <b>Language :-</b> {item.language}
                </p>

                {item.jobResponsibility && (
                  <p>
                    <b>Job Responsibilities :-</b> {item.jobResponsibility}
                  </p>
                )}

                {item.keyResponsibility && (
                  <div>
                    <b>Key Responsibilities :-</b>
                    <ul className="list-disc list-inside ml-5">
                      {(Array.isArray(item.keyResponsibility)
                        ? item.keyResponsibility
                        : item.keyResponsibility.split(",")
                      ).map((point, idx) => (
                        <li key={idx}>{point.trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {item.jobResponsibility1 && (
                  <div>
                    <b>Job Responsibilities :-</b>
                    <ul className="list-disc list-inside ml-5">
                      {(Array.isArray(item.jobResponsibility1)
                        ? item.jobResponsibility1
                        : item.jobResponsibility1.split(",")
                      ).map((point, idx) => (
                        <li key={idx}>{point.trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}

                <p>
                  <b>Reporting :-</b> {item.reporting}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Procedures Section */}
      <div className="container mt-2">
        <h2 className="text-2xl md:text-3xl font-bold text-[#274760] mb-3 text-center">
          PROCEDURES
        </h2>

        <Accordion
          type="multiple"
          defaultValue={ProceduresNew.map((item) => item.value)}
          className="border border-gray-300 rounded-lg"
        >
          {ProceduresNew.map((item) => (
            <AccordionItem value={item.value} key={item.value} className="">
              <AccordionTrigger className="w-full text-left px-4 py-3 bg-slate-300 hover:bg-gray-300 flex justify-between items-center font-semibold text-lg text-black hover:no-underline">
                {item.title}
              </AccordionTrigger>
              <AccordionContent className=" bg-white px-4">
                <ul className="list-disc space-y-3 text-md text-[16px] text-black">
                  {item.descriptionList.map((desc, idx) => (
                    <li key={idx}>{desc}</li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      {/* FAQs Section */}
      <div className="container mt-2">
        <h2 className="text-2xl md:text-3xl font-bold text-[#274760] mb-3 text-center">
          Frequently Asked Questions (FAQs)
        </h2>
        <div className="border border-gray-300 rounded-lg mb-3 overflow-hidden">
          <button
            onClick={() => handleToggle(0, "faq")}
            className="w-full text-left px-4 py-3 bg-slate-300 hover:bg-gray-300 flex justify-between items-center font-semibold text-black"
          >
            FAQs
            <span className="text-xl">{faqSelected === 0 ? "-" : "+"}</span>
          </button>
          {faqSelected === 0 && (
            <div className="bg-white p-4 space-y-2 text-gray-700">
              {FAQSNew().map((item, idx) => (
                <div key={idx} className="mb-4">
                  <h2 className="font-semibold text-lg mb-1">
                    &bull; {item.question}
                  </h2>
                  <p className="ml-4">{item.answer}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Rwo Vacancies Section */}
      <div className="container mt-8">
        {rwoVac.map((item, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-lg mb-3 overflow-hidden"
          >
            <button
              onClick={() => handleToggle(index, "rwo")}
              className="w-full text-left px-4 py-3 bg-slate-300 hover:bg-gray-300 flex justify-between items-center font-semibold text-black"
            >
              {item.title} {item.vacancy || ""}
              <span className="text-xl">{rwo === index ? "−" : "+"}</span>
            </button>

            {rwo === index && (
              <div className="bg-white p-4 space-y-2 text-gray-700">
                <p>
                  <b>Qualification :-</b> {item.qualifications}
                </p>
                <p>
                  <b>Preference (Not mandatory):-</b> {item.preference}
                </p>
                <p>
                  <b>Service Type :-</b> {item.serviceType}
                </p>
                <p>
                  <b>Salary :-</b> {item.salary}{" "}
                  {item.salary2 && `| ${item.salary2}`}
                </p>
                <p>
                  <b>Promotion :-</b> {item.promotion}
                </p>
                <p>
                  <b>Pension Scheme :-</b> {item.pensionScheme}
                </p>
                <p>
                  <b>Mediclaim Facility :-</b> {item.mediclaimFacility}
                </p>
                <p>
                  <b>Group Term Insurance :-</b> {item.groupTermInsurance}
                </p>
                <p>
                  <b>Age Limit :-</b> {item.ageLimit}
                </p>
                <p>
                  <b>Language :-</b> {item.language}
                </p>

                {item.jobResponsibility && (
                  <p>
                    <b>Job Responsibilities :-</b> {item.jobResponsibility}
                  </p>
                )}

                {item.keyResponsibility && (
                  <div>
                    <b>Key Responsibilities :-</b>
                    <ul className="list-disc list-inside ml-5">
                      {(Array.isArray(item.keyResponsibility)
                        ? item.keyResponsibility
                        : item.keyResponsibility.split(",")
                      ).map((point, idx) => (
                        <li key={idx}>{point.trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {item.jobResponsibility1 && (
                  <div>
                    <b>Job Responsibilities :-</b>
                    <ul className="list-disc list-inside ml-5">
                      {(Array.isArray(item.jobResponsibility1)
                        ? item.jobResponsibility1
                        : item.jobResponsibility1.split(",")
                      ).map((point, idx) => (
                        <li key={idx}>{point.trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}

                <p>
                  <b>Reporting :-</b> {item.reporting}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Brt2025;
